
const overrideFormControlStyles = () => ({
  MuiFormControlLabel: {

    styleOverrides: {
      root: {
        ":has(.MuiSwitch-root)": {
          ".MuiFormControlLabel-label": {
            fontSize: 14
          }
        }
      }
    }
  }
})

export default overrideFormControlStyles
